<nav class="hub-nav" aria-label="Workspace">
  @for (item of items; track item.label) {
    <button
      type="button"
      class="hub-nav__item"
      [class.hub-nav__item--active]="isActive(item)"
      [class.hub-nav__item--future]="item.futureLabel"
      [disabled]="!item.url"
      [attr.aria-current]="isActive(item) ? 'page' : null"
      [attr.title]="item.futureLabel ? item.label + ' — ' + item.futureLabel : item.label"
      (click)="navigate(item)"
      >
      <span class="hub-nav__label">{{ item.label }}</span>
      @if (item.futureLabel) {
        <span class="hub-nav__future">{{ item.futureLabel }}</span>
      }
    </button>
  }
</nav>
